import React from 'react';
import {
    withStyles,
    IconButton,
    ListItem,
    ListItemText,
    ListItemSecondaryAction,
    Grid,
    Typography,
    ButtonBase,
} from '@material-ui/core';

import {
    withRouter,
} from "react-router-dom"

import ChevronRightOutlinedIcon from '@material-ui/icons/ChevronRightOutlined';
import AppData from '../../model/AppData';
import MBack from '../view/MBack';
import DeviceEventEmitter, { EventName } from '../../control/event';
import DefaultAvatarImg from '../../images/change/default_avatar.png';
import AppConfig from '../../control/config';
import AppUtils from '../../control/apputlis';


class SysSettingDialog extends React.Component {
    constructor(props) {
        super(props);
        this._onItemClick = this._onItemClick.bind(this);
        this.state = {
            avatar: AppData.me.Pic,
        }
    }

    componentDidMount() {
        AppUtils.YMPush('MAIN', 'SysSettingDialog');
        window.prevLoadingJs();
    }

    componentWillUnmount() {
    }

    _onItemClick(idx) {
        switch (idx) {
            case 0:
                //关于我们
                this.props.history.push('/aboat');
                break;
            case 1:
                //检查更新 
                AppData.checkUpdate();
                break;
            case 2:
                //设置密码
                this.props.history.push('/setpwd')
                break;
            case 3:
                //退出登录
                this.logout();
                break;
            case 4:
                //返回
                break;
            default:
                break;
        }
    }

    logout = () => {
        AppData.logout();
        this.props.history.push('/');
    }

    render() {
        const { classes } = this.props;
        const { avatar } = this.state;
        return (
            <MBack title='设置'>
                <Grid style={{ height: 16 }}></Grid>
                <ListItem style={{ backgroundColor: '#fff', height: 50 }} button onClick={() => this._onItemClick(0)}>
                    <ListItemText primary={<Typography style={{ color: '#0D0D0D', fontSize: 13 }}>关于我们</Typography>} />
                    <ListItemSecondaryAction>
                        <IconButton className={classes.listItta} edge="end" onClick={() => this._onItemClick(0)}>
                            <ChevronRightOutlinedIcon style={{ color: '#CFCFCF', fontSize: 20 }} />
                        </IconButton>
                    </ListItemSecondaryAction>
                </ListItem>
                <ListItem style={{ backgroundColor: '#fff', height: 50 }} button onClick={() => this._onItemClick(1)}>
                    <ListItemText primary={<Typography style={{ color: '#0D0D0D', fontSize: 13 }}>检查更新</Typography>} />
                    <ListItemSecondaryAction>
                        <Grid container direction='row' justify='flex-end'>
                            <Typography style={{ color: '#878787', fontSize: 13 }}>{'v' + AppConfig.version}</Typography>
                            <IconButton className={classes.listItta} edge="end" onClick={() => this._onItemClick(1)}>
                                <ChevronRightOutlinedIcon style={{ color: '#CFCFCF', fontSize: 20 }} />
                            </IconButton>
                        </Grid>
                    </ListItemSecondaryAction>
                </ListItem>
                <ListItem style={{ backgroundColor: '#fff', height: 50 }} button onClick={() => this._onItemClick(2)}>
                    <ListItemText primary={<Typography style={{ color: '#0D0D0D', fontSize: 13 }}>设置密码</Typography>} />
                    <ListItemSecondaryAction>
                        <Grid container direction='row' justify='flex-end'>
                            <IconButton className={classes.listItta} edge="end" onClick={() => this._onItemClick(2)}>
                                <ChevronRightOutlinedIcon style={{ color: '#CFCFCF', fontSize: 20 }} />
                            </IconButton>
                        </Grid>
                    </ListItemSecondaryAction>
                </ListItem>
                {/* <ListItem style={{ backgroundColor: '#fff', height: 50 }} button onClick={() => this._onItemClick(1)}>
                    <ListItemText primary={<Typography style={{ color: '#0D0D0D', fontSize: 13 }}>清除缓存</Typography>} />
                    <ListItemSecondaryAction>
                        <IconButton className={classes.listItta} edge="end" aria-label="28M" onClick={() => this._onItemClick(0)}>
                            <Typography style={{ color: '#878787', fontSize: 14 }}>28M</Typography>
                            <ChevronRightOutlinedIcon style={{ color: '#CFCFCF', fontSize: 20 }} />
                        </IconButton>
                    </ListItemSecondaryAction>
                </ListItem> */}
                <Grid style={{ height: 25 }}></Grid>
                <Grid container justify='center' >
                    <ButtonBase
                        className={classes.logoutBtn}
                        onClick={() => this._onItemClick(3)}
                    >退 出</ButtonBase>
                </Grid>
            </MBack>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    logoutBtn: {
        background: 'linear-gradient(135deg, #15A5B6, #3AF23A)',
        borderRadius: 22.5,
        color: 'white',
        height: 45,
        width: "80%",
        margin: theme.spacing(5, 0, 2, 0),
        fontSize: 14,
        fontWeight: theme.typography.fontWeightBold,
    },
    icon: {
        color: '#E2E2E2',
        fontSize: 20,
    },
    avatar: {
        width: 70,
        height: 70,
        color: '#fff',
        backgroundSize: 'cover',
        backgroundImage: `url(${DefaultAvatarImg})`,
        marginRight: 15,
    },
    divider: {
        height: 1,
        padding: theme.spacing(0, 1.5, 0, 1.5),
        backgroundColor: '#F0F0F0',
    },
    listItta: {
        padding: theme.spacing(0, 1, 0, 0),
        textAlign: 'right',
    }

}))(SysSettingDialog));